"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bridgeAtom = bridgeAtom;
exports.enforceRemoveFunction = enforceRemoveFunction;
exports.makeKeyedResolver = void 0;

var _atom = require("atom");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _isFunction = _interopRequireDefault(require("transmute/isFunction"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _pipe = _interopRequireDefault(require("transmute/pipe"));

function bridgeAtom(createConnection) {
  var bridge = (0, _atom.atom)();
  var removeConnection = createConnection(function (nextValue) {
    return (0, _atom.reset)(bridge, nextValue);
  });
  (0, _atom.watchUnreferenced)(bridge, removeConnection);
  return bridge;
}

function enforceRemoveFunction(remove) {
  (0, _invariant.default)((0, _isFunction.default)(remove), 'expected `getSubscription(...)` to return a function but got `%s`', remove);
  return remove;
}

var makeKeyedResolver = function makeKeyedResolver() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$idTransform = _ref.idTransform,
      idTransform = _ref$idTransform === void 0 ? _identity.default : _ref$idTransform,
      _ref$valueTransform = _ref.valueTransform,
      valueTransform = _ref$valueTransform === void 0 ? _identity.default : _ref$valueTransform;

  return function (getSubscription) {
    var getAtom = (0, _memoize.default)(function (id) {
      return bridgeAtom(function (next) {
        var validNext = (0, _pipe.default)(valueTransform, next);
        var remove = enforceRemoveFunction(getSubscription(id, validNext));
        return function () {
          remove();
          getAtom.cache.remove(id);
        };
      });
    });
    var result = (0, _pipe.default)(idTransform, getAtom);
    result.cache = getAtom.cache;
    return result;
  };
};

exports.makeKeyedResolver = makeKeyedResolver;